// extracted by mini-css-extract-plugin
module.exports = {"error404":"Error404_error404__CYr_6","header":"Error404_header__euOhR","text":"Error404_text__e6cZJ"};